import { STORAGE_KEY_PREFIX } from "../constants";

const localStorageKey = `${STORAGE_KEY_PREFIX}.theme`;
export type Theme = "dark" | "light";

export function setTheme(theme: Theme) {
  localStorage.setItem(localStorageKey, theme);
  document.documentElement.setAttribute("data-theme", theme);
}

export function getTheme(): Theme {
  const storedTheme = localStorage.getItem(localStorageKey);

  if (storedTheme) {
    return storedTheme as Theme;
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function applyTheme() {
  const theme = getTheme();

  if (theme === "dark") {
    setTheme("dark");
  } else if (theme === "light") {
    setTheme("light");
  }
}
